import {createServerFn} from '@tanstack/react-start';
import {Profile} from '@/apiTypes/profile';
import {z} from 'zod';

const FlagProfileInput = Profile.pick({id: true, email: true, level: true}).nullable();

/**
 * Server function that evaluates all feature flags in a single pass.
 * Wraps the server-only LaunchDarkly client behind an RPC bridge
 * so it can be called from route loaders and beforeLoad hooks.
 *
 * Accepts an optional profile to evaluate flags with user identity
 * for targeted rollouts (e.g. by role or email).
 */
export const getAllFeatureFlags = createServerFn({method: 'GET'})
  .inputValidator(
    (data: unknown): z.infer<typeof FlagProfileInput> => {
      const result = FlagProfileInput.safeParse(data);
      if (!result.success) return null;
      return result.data;
    },
  )
  .handler(async ({data}) => {
    const {getAllFeatureFlags: getFlags} = await import(
      '@/server/featureFlags.server'
    );
    return getFlags(data);
  });
